import React from "react";
import styles from "./PaymentMethod.module.sass";
import product from "../../../i11/Product";
import Checkbox from "../../Checkbox";
import { useUser } from "../../../context";
import Dropdown from "../../Dropdown";
import Tooltip from "../../Tooltip";

const PaymentDueDates = [
	"DAY",
	"DAYS7",
	"DAYS14",
	"DAYS30",
	"DAYS45",
	"DAYS60",
	"DAYS90",
];

// ["CARD_PAYMENT", "INVOICE_PAYMENT"];

const PaymentMethod = ({ isDisable, setLocal, local }) => {
	const { locale } = useUser();

	const handler = (name, value) => {
		if (isDisable) return;
		setLocal((v) => {
			return {
				...v,
				[name]: value,
			};
		});
	};

	return (
		<div className={styles.payment_method}>
			<div className={styles.row}>
				<p>{product[locale].pm?.title || ""}</p>
				<Tooltip
					className={styles.tooltip}
					title={product[locale].pm.tooltip}
					icon="info"
					place="right"
				/>
			</div>
			<div className={styles.row}>
				<Checkbox
					value={local.paymentType === "CARD_PAYMENT"}
					onChange={() => handler("paymentType", "CARD_PAYMENT")}
					content={product[locale].pm.card_payment || "card_payment"}
				/>
				<Checkbox
					value={local.paymentType === "INVOICE_PAYMENT"}
					onChange={() => handler("paymentType", "INVOICE_PAYMENT")}
					content={product[locale].pm.invoice_payment}
				/>
			</div>
			{local.paymentType === "INVOICE_PAYMENT" && (
				<Dropdown
					isDisabled={isDisable}
					label={product[locale].pm.payment_due_date}
					value={local.period_time || PaymentDueDates[0]}
					setValue={(v) => handler("period_time", v)}
					options={PaymentDueDates}
				/>
			)}
		</div>
	);
};

export default PaymentMethod;
